import type { UnifiedThemeOptions } from '@backstage/theme';
import { essityBrand } from './colours';

export const createEssityComponents = (
  divider: string,
): NonNullable<UnifiedThemeOptions['components']> => ({
  BackstageHeader: {
    styleOverrides: {
      header: {
        width: '100%',
        margin: 0,
        borderBottom: `6px solid ${essityBrand.pink}`,
        boxShadow: 'none',
      },
    },
  },
  BackstageItemCardHeader: {
    styleOverrides: {
      root: ({ theme }) => ({
        paddingBottom: theme.spacing(2),
        borderBottom: `3px solid ${essityBrand.pink}`,
        // The title is an h4 and gets a 6px margin from the heading typography.
        '& > h4': { marginBottom: 0 },
      }),
    },
  },
  BackstageSidebar: {
    styleOverrides: {
      drawer: {
        '& .MuiDrawer-paper': { borderRight: `1px solid ${divider}` },
      },
    },
  },
});
